export const getWeatherDay = () => {
  return new Date().getDate();
};